import { render, staticRenderFns } from "./ModifyingInternalSystem.vue?vue&type=template&id=2471998e&"
import script from "./ModifyingInternalSystem.vue?vue&type=script&lang=js&"
export * from "./ModifyingInternalSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports